module.exports = __webpack_public_path__ + "img/menu-dot.f97ec464.svg";